import { Permission } from '../../../../../backend/src/auth/permissions/permission';
import relativityLogo from '@/assets/relativity.png';
import { useUserContext } from '@/Contexts/User';
import { PermissionGate } from '@/hooks/useHasPermission';

interface IntegrationBarProps {
  onRelativityConnect: () => void;
}

export function IntegrationBar({ onRelativityConnect }: IntegrationBarProps) {
  const { user } = useUserContext();

  const isRelativityFullySetup = !!(
    user?.organisation.relativitySite &&
    user?.organisation.relativityClientId &&
    user?.organisation.relativityClientSecretEncrypted
  );

  if (!isRelativityFullySetup) return null;

  return (
    <div className="flex flex-wrap justify-center gap-1.5 border-b border-gray-100 pb-4">
      <PermissionGate
        permission={Permission.RelativityImport}
        uiMode="disabled"
        disabledMessage="You do not have permission to import from Relativity"
      >
        <button
          type="button"
          title="Import from Relativity"
          onClick={onRelativityConnect}
          className="group relative flex w-fit cursor-pointer items-center justify-center rounded-lg border border-gray-300 bg-white p-2.5 transition-all duration-200 hover:border-teal-500"
        >
          <img src={relativityLogo} alt="Relativity" className="size-5 rounded-lg object-cover" />
        </button>
      </PermissionGate>
    </div>
  );
}
